import React, { Suspense, lazy } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Zap } from 'lucide-react';
import { Skeleton } from '@/components/ui/skeleton';

// Lazy-load QuickSearch — chunk is prefetched by RequestForm so it's usually warm
const QuickSearch = lazy(() => import('@/pages/QuickSearch'));

interface QuickSearchDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const QuickSearchDialog: React.FC<QuickSearchDialogProps> = ({ open, onOpenChange }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl w-[95vw] h-[85vh] p-0 flex flex-col gap-0 overflow-hidden">
        <DialogHeader className="px-5 py-4 border-b bg-gradient-to-r from-brand-teal/10 to-brand-teal-light/10 shrink-0">
          <DialogTitle className="flex items-center gap-2 text-brand-navy">
            <Zap className="h-5 w-5 text-brand-teal fill-brand-teal" />
            {t('quickSearch.dialogTitle')}
          </DialogTitle>
        </DialogHeader>

        <div className="flex-1 overflow-hidden">
          {open && (
            <Suspense
              fallback={
                <div className="p-4 space-y-2">
                  <Skeleton className="h-10 w-full" />
                  <Skeleton className="h-24 w-full" />
                  <Skeleton className="h-24 w-full" />
                </div>
              }
            >
              <QuickSearch isEmbedded onNavigate={() => onOpenChange(false)} />
            </Suspense>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default QuickSearchDialog;
